//@ts-nocheck
import { useState, useEffect } from "react";
import { Fade } from "react-awesome-reveal";
import { RiRobot2Line } from "react-icons/ri";
import { HiOutlineUserCircle } from "react-icons/hi2";
import { FaArrowUpLong } from "react-icons/fa6";
import ChatIntro from "./chatIntro";
import apiClient from "../../../../services/apiClient";
import useStore from "../../../../features/store";
import ChatIcon from "../../../../assets/images/bot-icon.png";

const ChatWithTest = ({ testInfo, footerButtons }: any) => {
  const { addChatMessage, getChatHistoryForTest }: any = useStore();
  const [messages, setMessages] = useState<
    Array<{ text: string; isUser: boolean }>
  >([]);
  const [inputMessage, setInputMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingHistory, setIsLoadingHistory] = useState(true);
  const [showChat, setShowChat] = useState(false);
  const [isChatActive, setIsChatActive] = useState(
    testInfo.allow_to_chat ? true : false
  );

  useEffect(() => {
    const fetchChatHistory = async () => {
      setIsLoadingHistory(true);
      try {
        const response = await apiClient.get(
          `/test-records/${testInfo.test_id}/chat/`
        );

        if (response.data && Object.keys(response.data).length > 0) {
          const chatData = Array.isArray(response.data)
            ? response.data
            : Object.values(response.data);

          if (chatData.length > 0) {
            chatData.sort((a, b) => (a.id || 0) - (b.id || 0));

            const apiMessages = chatData.map((item) => ({
              text: item.message,
              isUser: item.is_user,
            }));

            setMessages(apiMessages);
            setShowChat(true);

            for (let i = 0; i < chatData.length; i += 2) {
              if (i + 1 < chatData.length) {
                const question = chatData[i];
                const answer = chatData[i + 1];

                if (question.is_user && !answer.is_user) {
                  addChatMessage(
                    testInfo.test_id,
                    question.message,
                    answer.message
                  );
                }
              }
            }
            setIsLoadingHistory(false);
            return;
          }
        }

        const localHistory = getChatHistoryForTest(testInfo.test_id);
        if (localHistory.length > 0) {
          const formattedMessages = localHistory.flatMap((item) => [
            { text: item.question, isUser: true },
            { text: item.answer, isUser: false },
          ]);

          setMessages(formattedMessages);
          setShowChat(true);
        }
        setIsLoadingHistory(false);
      } catch (error) {
        const localHistory = getChatHistoryForTest(testInfo.test_id);
        if (localHistory.length > 0) {
          const formattedMessages = localHistory.flatMap((item) => [
            { text: item.question, isUser: true },
            { text: item.answer, isUser: false },
          ]);

          setMessages(formattedMessages);
          setShowChat(true);
        }
        setIsLoadingHistory(false);
      }
    };

    fetchChatHistory();
  }, [testInfo.test_id, getChatHistoryForTest, addChatMessage]);

  const handleSendMessage = async (message: string = inputMessage) => {
    if ((!message.trim() && !inputMessage.trim()) || isLoading) return;

    const userMessage = message.trim() ? message : inputMessage.trim();

    setShowChat(true);

    setMessages([...messages, { text: userMessage, isUser: true }]);
    setInputMessage("");
    setIsLoading(true);

    try {
      const response = await apiClient.post(
        `/test-records/${testInfo.test_id}/chat/`,
        {
          message: userMessage,
          id: testInfo.test_id,
        }
      );

      const answer = response.data.messages || "جوابی دریافت نشد";
      setMessages((prev) => [
        ...prev,
        {
          text: answer,
          messages_left: response.data.number_of_messages_left,
          isUser: false,
        },
      ]);

      if (response.data.number_of_messages_left < 1) setIsChatActive(false);

      addChatMessage(testInfo.test_id, userMessage, answer);
    } catch (error) {
      const errorMessage = "مشکلی در ارتباط با سرور پیش اومده.";
      setMessages((prev) => [
        ...prev,
        {
          text: errorMessage,
          isUser: false,
        },
      ]);
      addChatMessage(testInfo.test_id, userMessage, errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  if (isLoadingHistory) {
    return (
      <div className="h-full min-h-[350px] p-5 border rounded-xl flex flex-col items-center justify-center">
        <div className="flex flex-col items-center">
          <img src={ChatIcon} className="w-20" alt="chat" />
          <p className="text-sm flex items-center mt-5 font-rokh font-[700]">
            در حال بارگذاری تاریخچه بادی‌گپ
            <span className="loading loading-dots loading-sm mr-2"></span>
          </p>
        </div>
      </div>
    );
  }

  if (!showChat && messages.length === 0) {
    return (
      <>
        <ChatIntro testInfo={testInfo} onSendQuestion={handleSendMessage} />
      </>
    );
  }

  return (
    <div>
      <div className="flex items-center mb-10">
        <img src={ChatIcon} className="w-12 ml-5" alt="chat" />
        <div className="flex flex-col items-start mt-2">
          <h2 className="text-xl font-rokh font-[900] text-center">بادی‌گپ</h2>
          <p className="text-sm lg:text-base font-rokh font-[700] text-center">
            سوالاتی که در مورد آزمایشت داری رو اینجا بپرس
          </p>
        </div>
      </div>
      <div className="h-full min-h-[550px] p-5 lg:p-10 border rounded-xl flex flex-col">
        <div className="flex-1 mb-4">
          {messages.map((message, index) => (
            <div
              key={index}
              className={`mb-2 p-3 w-auto flex flex-col lg:flex-row rounded-md `}
            >
              {message.isUser ? (
                <div className="min-w-[50px]">
                  <HiOutlineUserCircle
                    size={28}
                    className="mb-2 lg:ml-2 lg:mb-0"
                  />{" "}
                </div>
              ) : (
                <div className="min-w-[50px]">
                  <RiRobot2Line size={28} className="mb-2 lg:ml-2 lg:mb-0" />{" "}
                </div>
              )}
              <Fade triggerOnce>
                <p
                  className={`text-right text-sm ${
                    message.isUser ? "bg-gray-100 py-2 px-5 rounded" : "p-1"
                  }`}
                >
                  {message.text}
                </p>
              </Fade>
            </div>
          ))}
          {isLoading && (
            <div className="mb-2 p-3 rounded-lg flex items-center">
              <RiRobot2Line size={28} className="ml-6" />
              <p className="text-sm flex items-center">
                در حال بررسی
                <span className="loading loading-dots loading-sm mr-2"></span>
              </p>
            </div>
          )}
        </div>

        <div className="flex mt-auto relative">
          <textarea
            type="text"
            value={inputMessage}
            onChange={(e) => setInputMessage(e.target.value)}
            onKeyDown={handleKeyPress}
            maxLength={200}
            rows={4}
            placeholder={isChatActive ? "سوالت رو اینجا بنویس" : ""}
            className="bg-gray-100 flex-1 p-[12px] border rounded-lg focus:outline-none text-xs lg:text-sm pl-14"
            disabled={isLoading || !isChatActive}
          />
          <button
            onClick={() => handleSendMessage()}
            disabled={isLoading || !isChatActive}
            className={`${
              !inputMessage
                ? "bg-gray-200 text-gray-500"
                : "bg-blue-500 text-white"
            } ${
              isChatActive
                ? "hover:bg-blue-600 transition-colors cursor-pointer"
                : "cursor-default"
            } absolute bottom-2 left-3 rounded-full p-2 `}
          >
            <FaArrowUpLong size={12} />
          </button>
        </div>
        {5 - messages?.filter((msg: any) => msg.isUser).length > 0 && (
          <p className="mt-1 text-xs text-gray-600">
            <strong className="ml-1">
              {5 - messages.filter((msg: any) => msg.isUser).length}
            </strong>
            سوال باقیمانده
          </p>
        )}
        {!isChatActive && (
          <p className="mt-1 text-pr_red_dark text-xs text-right font-[900]">
            تعداد سوال‌های مجاز تکمیل شد و امکان ثبت سوال جدید وجود نداره
          </p>
        )}
      </div>
    </div>
  );
};

export default ChatWithTest;
